<template>
    <div class="rackContainer">
        <div 
            class="titleContainer" 
            :class="rack.active ? 'active-rack' : null"
            @contextmenu="openRackMenu($event)">
            <h5>{{ rack.ra_label }}</h5>
        </div>
        <div class="rackDiagramContainer">
            <rack-position
                v-for="(position, index) in rack.drawers.slice().reverse()" 
                :position="position"
                :key="index"
                @open-menu="openMenu"
                @set-active-position="setActivePosition"
                @start-drag="startDrag"
                @end-drag="endDrag"
            />
        </div>
    </div>
</template>
  
<script>
import RackPosition from './RackPosition.vue';
  export default {
    name: "Rack",
    components: {
        RackPosition
    },
    props: {
      rack: {
        type: Object,
      },
    },
    methods: {
        openMenu(horizontal, vertical, isEmptyPosition, position){
            this.$emit('open-menu',horizontal, vertical, isEmptyPosition, position);
        },
        openRackMenu(e){
            const horizontal = e.clientX;
            const vertical = e.clientY;
            e.preventDefault();
            this.$emit('open-rack-menu', horizontal, vertical, this.rack);
        },
        setActivePosition(obj){
            this.$emit('set-active-position', obj);
        },
        startDrag(e, position){
            this.$emit('start-drag', e, position);
        },
        endDrag(e, position){
            this.$emit('end-drag', e, position);
        }
    }
  }
</script>
  
<style scoped>
.rackContainer{
    min-width: 300px;
    height: 100%;
    padding-bottom: 5px;
}
.titleContainer{
    width: 240px;
    height: 34px;
    box-sizing: border-box;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    padding: 8px 0px;
    background-color: #4fa2b7 ;
    color: white;
}
.rackDiagramContainer{
    width: 100%;
    height: calc(100% - 34px);
    padding-right: 30px;
    overflow-y: scroll;
}
.active-rack{
    border: 3px solid #93d7e9;
    background-color: rgba(79, 162, 183, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/Rack.vue